
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'

import { SeProgressBarComponent } from './progress-bar.component'

@NgModule({
  imports: [
	CommonModule
  ],
  declarations: [
    SeProgressBarComponent
  ],
  exports: [
    SeProgressBarComponent
  ]
})
export class SeProgressBarModule {}

export const SE_PROGRESS_BAR_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.progressBar`

